export const AGENCY_ACL_OBJECTS = [
    'Agency',
    'AgencyNew',
    'AgencyDetail'
];
